import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";

export const TabList = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.border?.stroke ?? rawColors.stroke[200]};
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
